define('plugin/bonus/view/ClientInfoBonusItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Product item view
     *
     * @class ProductItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            return '#bonus_system_info_item_view';
        },
        ui: {

        },
        events: {

        },

    });

});
